import React from "react";
import Policy from "./Policy.jsx";
import CancelPolicySkeleton from "./Skeletons/CancelPolicySkeleton.jsx";
import Card from "../common/Card";

const CancellationPolicyBanner = ({
  loading,
  multiplePolicies,
  multiplePoliciesSpecific,
  allowCancel,
  allowUpdate,
  producerName,
  hasCancellationPolicySection,
  cancellationPolicy, 
  isReleaseSeatAllowed, 
  releaseSeatPolicy, 
  releaseSeatDays
}) => {
  const renderPolicyContent = () => {
    if (multiplePoliciesSpecific)
      return (
        <div className="r_multipleCancellationPoliciesText">
          {cancellationpolicy_resources.MultipleCancellationPolicies}
        </div>
      );

    return (
      <Policy
        allowCancel={allowCancel}
        allowUpdate={allowUpdate}
        producerName={producerName}
        cancellationPolicy={cancellationPolicy} 
        isReleaseSeatAllowed={isReleaseSeatAllowed}
        releaseSeatPolicy={releaseSeatPolicy} 
        releaseSeatDays={releaseSeatDays}
      />
    );
  };

  if (loading) return <CancelPolicySkeleton />;

  if (hasCancellationPolicySection)
    return (
      <div className="CancellationPolicyInfoDiv">
        <Card
          title={cancellationpolicy_resources.CancellationPolicyHeaderText}
          icon="/Site/images/icons/eventpage/cancellation.svg"
          size="bold"
          noContentPadding
          noMargin
        >
          {renderPolicyContent()}
        </Card>
      </div>
    );

  return "";
};

export default CancellationPolicyBanner;
